export const NAME = 'profile';
export const ALLOWED_EXTENSIONS = 'image/png,image/jpeg,image/jpg';
